import { BaseModel } from "./base.model";
import { registerColumnModels } from "./column.model.js";
import { registerFieldModels } from "./field.model.js";
import { registerFormModels } from "./form.model";

export * from "./base.model";
export * from "./datastore";
export * from "./field.types";
export * from "./form.model";
export * from "./column.model.js";
export * from "./field.model.js";
export * from "./process.model";
export * from "./case.model";
export * from "../constants";
export * from "./report.model";

export function registerModels() {
  BaseModel.reset();
  registerFormModels();
  registerFieldModels();
  registerColumnModels();
}
